module.exports = __webpack_public_path__ + "media/organizations/fom-9d25cc6b.svg";